import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'comandă la masă',
    [ORDER_METHODS.PICKUP]: 'ridicare',
    [ORDER_METHODS.DELIVERY]: 'livrare',
  },
  errors: {
    draft_validation_failed: 'Te rugăm să completezi adresa de livrare înainte de a continua.',
  },
};
